import { getTheme } from '@fluentui/react';

export const theme = getTheme();

export const surveyMaxWidth = 480;

export const iconButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: 'auto',
    marginTop: '4px',
    marginRight: '2px',
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};

export const closeButtonStyles = {
  ...iconButtonStyles,
  root: {
    ...iconButtonStyles.root,
    '&:focus::after': {
      width: '22px',
      transform: 'translateX(-1px)',
    },
  },
};

export const backButtonStyles = {
  ...iconButtonStyles,
  root: {
    ...iconButtonStyles.root,
    '&:focus::after': {
      width: '22px',
      transform: 'translateX(-5px)',
    },
  },
};

export const modalStyles = ({
  modalView: {
    zIndex: 1000001,
  },
});

export const surveyStyles = ({
  container: {
    padding: 24,
    maxWidth: surveyMaxWidth,
  },
  body: {
    color: theme.palette.neutralPrimary,
    '& .question-block ~ .question-block': {
      marginTop: '16px',
    },
    '& .question-block': {
      '& .customized-option label, .checkbox-group label': {
        padding: 'unset',
        fontWeight: 'unset',
      },
    },
  },
});
